<template>
  <div class="process-node">
    <page-header title="流程节点配置" icon="el-icon-setting" />
    <el-card class="box-card">
      <el-form ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="流程类型">
              <el-input v-model="form.type" placeholder="请输入流程类型" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程名称">
              <el-input v-model="form.name" placeholder="请输入流程名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程状态">
              <el-input v-model="form.status" placeholder="请输入流程状态" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="流程说明">
              <el-input type="textarea" v-model="form.description" :rows="3" placeholder="请输入流程说明"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 操作按钮 -->
        <el-row>
          <el-col :span="24">
            <div class="button-container">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
              <!-- <el-button type="danger" size="small" icon="el-icon-delete" @click="handleBatchDelete">删除流程</el-button> -->
              <el-button size="small" icon="el-icon-back" @click="handleBack">返回</el-button>
            </div>
          </el-col>
        </el-row>

        <!-- 节点表格 -->
        <el-table :data="tableData" style="width: 100%" border @selection-change="handleSelectionChange">
         
          <el-table-column prop="step" label="节点步骤" width="120" align="center"></el-table-column>
          <el-table-column prop="type" label="节点类型" width="180" align="center">
            <template slot-scope="scope">
              <el-tag size="medium">{{ getNodeKindText(scope.row.nodeKind) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="节点名称" align="center"></el-table-column>
          <el-table-column prop="description" label="节点人员" align="center">
            <template slot-scope="scope">
              <el-tooltip 
                :content="scope.row.description" 
                placement="top" 
                :disabled="!scope.row.description">
                <span>{{ scope.row.description || '-' }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="handleConfigUser(scope.row)">人员节点</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <!-- 添加新增节点弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="450px" append-to-body>
        <el-form :model="nodeForm" ref="nodeForm" label-width="80px">
          <el-form-item label="节点步骤">
            <el-input-number 
              v-model="nodeForm.step" 
              :min="1" 
              :max="99"
              controls-position="right"
              style="width: 100%">
            </el-input-number>
          </el-form-item>
          <el-form-item label="节点类型">
            <el-select v-model="nodeForm.type" placeholder="请选择节点类型" style="width: 100%">
              <el-option label="串行" value="1"></el-option>
              <el-option label="并行与" value="2"></el-option>
              <el-option label="并行或" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="节点名称">
            <el-input v-model="nodeForm.name" placeholder="请输入节点名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="节点描述">
            <el-input 
              type="textarea" 
              v-model="nodeForm.description" 
              placeholder="请输入内容"
              :rows="3">
            </el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 添加人员节点配置弹窗 -->
      <el-dialog title="人员节点" :visible.sync="userDialogVisible" width="450px" append-to-body>
        <el-form :model="userForm" ref="userForm" label-width="80px">
          <el-form-item label="节点步骤">
            <el-input-number 
              v-model="userForm.step" 
              :min="1" 
              :max="99"
              controls-position="right"
              style="width: 100%"
              disabled>
            </el-input-number>
          </el-form-item>
          <el-form-item label="节点类型">
            <el-input 
              v-model="nodeTypeText" 
              disabled
              placeholder="节点类型"
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item label="节点人员">
            <treeselect
              ref="treeselect"
              v-model="userForm.users"
              :multiple="!userForm.isSingle"
              :options="organizationTree"
              :normalizer="normalizer"
              :disable-branch-nodes="true"
              :flat="false"
              :default-expand-level="1"
              :clear-on-select="false"
              :close-on-select="userForm.isSingle"
              placeholder="请选择节点人员"
              style="width: 100%"
              @input="handleUserSelectionChange"
            >
              <label 
                slot="option-label" 
                slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
              >
                <i 
                  :class="node.raw.type === 'dept' ? 'el-icon-folder' : 'el-icon-user'"
                  :style="{ 
                    color: node.raw.type === 'dept' ? '#909399' : '#409EFF', 
                    marginRight: '8px' 
                  }"
                ></i>
                <span :class="labelClassName">{{ node.label }}</span>
              </label>
            </treeselect>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="userDialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="saveUserConfig">保存</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'ProcessNode',
  components: {
    PageHeader,
    Treeselect
  },
  data() {
    return {
      form: {
        type: '',
        name: '',
        status: '',
        description: ''
      },
      tableData: [

      ],
      selectedRows: [],
      dialogVisible: false,
      dialogTitle: '新增节点',
      isEdit: false,
      nodeForm: {
        nodeId: '',
        step: 1,
        type: '',
        name: '',
        description: ''
      },
      userDialogVisible: false,
      userForm: {
        step: 1,
        type: '',
        users: [],
        isSingle: true,
        nodeId: '',
        approverType: 1
      },
      userOptions: [
        { value: 'user1', label: '张三' },
        { value: 'user2', label: '李四' },
        { value: 'user3', label: '王五' },
        { value: 'user4', label: '赵六' }
      ],
      processId: '',
      organizationTree: [],
      nodeTypeConfig: {
        '1': { label: '串行', isSingle: true },
        '2': { label: '并行一', isSingle: false },
        '3': { label: '并行二', isSingle: false }
      },
      normalizer(node) {
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          isDisabled: false
        }
      },
      nodeTypeText: ''
    }
  },
  methods: {
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增节点'
      this.nodeForm = {
        nodeId: '',
        step: this.tableData.length + 1,
        type: '',
        name: '',
        description: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '修改节点'
      this.nodeForm = {
        nodeId: row.nodeId,
        step: parseInt(row.step) || 1,
        type: row.nodeKind ? row.nodeKind.toString() : '',
        name: row.name || '',
        description: row.description || ''
      }
      this.dialogVisible = true
    },
    handleConfigUser(row) {
      const isSingle = row.nodeKind === '1'
      
      this.nodeTypeText = this.getNodeKindText(row.nodeKind)
      
      const selectedUsers = (row.approvers || []).map(approver => `user_${approver.userId}`)
      
      this.userForm = {
        step: row.step,
        users: selectedUsers,
        isSingle: isSingle,
        nodeId: row.nodeId,
        approverType: row.type
      }
      this.userDialogVisible = true
    },
    async saveUserConfig() {
      try {
        const users = Array.isArray(this.userForm.users) ? this.userForm.users : [this.userForm.users]
        
        if (!users.length || !users[0]) {
          this.$message.warning('请选择节点人员')
          return
        }
        
        const userIds = users
          .filter(id => id && typeof id === 'string')
          .map(id => id.replace('user_', ''))
        
        if (!userIds.length) {
          this.$message.warning('没有有效的用户选择')
          return
        }

        const params = {
          processId: this.processId,
          step: this.userForm.step,
          approverIds: userIds,
          approverType: this.userForm.approverType,
          nodeId: this.userForm.nodeId
        }

        const res = await request({
          url: '/api/v1/process/node/approver/save',
          method: 'POST',
          data: params
        })

        if (res.status === 1) {
          this.$message.success('人员配置保存成功')
          this.userDialogVisible = false
          await this.fetchNodeList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存人员配置错误:', error)
        this.$message.error('保存失败: ' + (error.message || '未知错误'))
      }
    },
    async fetchNodeList() {
      try {
        const res = await request({
          url: '/api/v1/process/node/list',
          method: 'POST',
          data: {
            processId: this.processId
          }
        })

        if (res.status === 1) {
          if (res.data) {
            this.tableData = res.data.map(item => ({
              step: item.step,
              type: item.nodeType,
              name: item.nodeName,
              description: this.formatApprovers(item.approvers),
              nodeId: item.nodeId,
              nodeKind: item.nodeType,
              approvers: item.approvers || []
            }))
          }
          
          let process = res.process
          this.form.type = process.processKindName
          this.form.name = process.processName
          this.form.status = process.status == 1 ? '启用' : '禁用'
          this.form.description = process.description
        } else {
          this.$message.error(res.msg || '获取节点列表失败')
        }
      } catch (error) {
        console.error('获取节点列表错误:', error)
      }
    },
    formatApprovers(approvers) {
      if (!approvers || !Array.isArray(approvers)) return '';
      return approvers.map(approver => approver.realName || approver.username).join('、');
    },
    async handleSubmit() {
      try {
        if (!this.nodeForm.type || !this.nodeForm.name) {
          this.$message.warning('请填写必要信息')
          return
        }

        const params = {
          processId: this.processId,
          nodeName: this.nodeForm.name,
          nodeKind: parseInt(this.nodeForm.type),
          nodeStep: parseInt(this.nodeForm.step),
          nodeId: this.nodeForm.nodeId || '',
          description: this.nodeForm.description || ''
        }

        console.log('提交的参数:', params)

        const res = await request({
          url: '/api/v1/process/node/save',
          method: 'POST',
          data: params
        })

        if (res.status === 1) {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchNodeList()
        } else {
          this.$message.error(res.msg || (this.isEdit ? '修改失败' : '新增失败'))
        }
      } catch (error) {
        console.error('保存节点错误:', error)
        this.$message.error(this.isEdit ? '修改失败' : '新增失败')
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该节点?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/process/node/delete',
          method: 'POST',
          data: {
            nodeId: row.nodeId
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchNodeList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除节点错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    getNodeKindText(nodeKind) {
      switch (parseInt(nodeKind)) {
        case 1:
          return '串行'
        case 2:
          return '并行与'
        case 3:
          return '并行或'
        default:
          return '未知'
      }
    },
    handleBack() {
      this.$router.push('/process/ProcessFlow')
    },
    async fetchOrganizationData() {
      try {
        const deptRes = await request({
          url: '/api/v1/dept/list ',
          method: 'POST',
          data: { name: '', status: -1 }
        })
        
        const userRes = await request({
          url: '/api/v1/user/all',
          method: 'POST',
          data: {}
        })
        
        console.log('部门数据响应:', deptRes)
        console.log('用户数据响应:', userRes)
        
        if (deptRes.status === 1 && userRes.status === 1) {
          const depts = Array.isArray(deptRes.data) ? deptRes.data : []
          const users = Array.isArray(userRes.data) ? userRes.data : []
          
          if (depts.length === 0) {
            console.warn('No departments data received')
          }
          if (users.length === 0) {
            console.warn('No users data received')
          }
          
          this.buildOrganizationTree(depts, users)
        } else {
          throw new Error('Failed to fetch organization data')
        }
      } catch (error) {
        console.error('获取组织架构数据失败:', error)
        this.$message.error('获取组织架构数据失败')
      }
    },
    buildOrganizationTree(depts, users) {
      try {
        const deptMap = {}
        const deptTree = []
        console.log('用户数据:', users)
        
        depts.forEach(dept => {
          const formattedDept = {
            id: `dept_${dept.dept_id}`,
            label: dept.dept_name,
            children: [],
            type: 'dept',
            deptId: dept.dept_id,
            isDisabled: true
          }
          deptMap[dept.dept_id] = formattedDept
        })
        
        depts.forEach(dept => {
          const deptNode = deptMap[dept.dept_id]
          if (dept.parent_id === '0') {
            deptTree.push(deptNode)
          } else {
            const parentNode = deptMap[dept.parent_id]
            if (parentNode) {
              parentNode.children.push(deptNode)
            }
          }
        })
        
        if (Array.isArray(users)) {
          users.forEach(user => {
            if (!user || !user.userId) {
              console.warn('Invalid user data:', user)
              return
            }

            const userNode = {
              id: `user_${user.userId}`,
              label: user.realName || user.username,
              type: 'user',
              userId: user.userId,
              deptId: user.deptId,
              isDisabled: false
            }
            
            const deptNode = deptMap[userNode.deptId]
            if (deptNode) {
              deptNode.children.push(userNode)
            } else {
              console.warn('User without valid department:', user)
            }
          })
        }
        
        this.organizationTree = deptTree
        console.log('组织架构树:', this.organizationTree)
      } catch (error) {
        console.error('构建组织架构树错误:', error)
        this.$message.error('构建组织架构树失败')
      }
    },
    handleUserSelectionChange(value) {
      try {
        if (JSON.stringify(value) === JSON.stringify(this.userForm.users)) {
          return;
        }

        if (this.userForm.isSingle) {
          if (Array.isArray(value) && value.length > 0) {
            const lastSelectedId = value[value.length - 1];
            if (lastSelectedId.startsWith('user_')) {
              this.$set(this.userForm, 'users', [lastSelectedId]);
            }
          } else if (!Array.isArray(value) && value) {
            this.$set(this.userForm, 'users', [value]);
          } else {
            this.$set(this.userForm, 'users', []);
          }
        } else {
          const filteredUsers = Array.isArray(value) 
            ? value.filter(id => id.startsWith('user_'))
            : [];
          this.$set(this.userForm, 'users', filteredUsers);
        }
        
        console.log('选中的用户:', this.userForm.users);
      } catch (error) {
        console.error('处理用户选择变化错误:', error);
      }
    }
  },
  created() {
    this.processId = this.$route.params.id
    console.log('流程ID:', this.processId)
    
    if (!this.processId) {
      this.$message.error('未获取到流程ID')
      return
    }
    
    this.fetchNodeList()
    this.fetchOrganizationData()
  },
  
  watch: {
    'userForm.type': {
      handler(newType, oldType) {
        if (!newType || newType === oldType) return;
        
        console.log('节点类型变化:', oldType, '->', newType);
        const isSingle = newType === 'audit';
        
        if (this.userForm.isSingle !== isSingle) {
          this.$set(this.userForm, 'isSingle', isSingle);
          this.$set(this.userForm, 'users', []);
          
          this.$nextTick(() => {
            const treeselect = this.$refs.treeselect;
            if (treeselect) {
              treeselect.clear();
            }
          });
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.process-node {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .box-card {
    margin-bottom: 20px;
  }

  .button-container {
    margin: 15px 0;
    display: flex;
    justify-content: left;
  }

  .button-container .el-button + .el-button {
    margin-left: 10px;
  }

  .button-container .el-icon-back {
    margin-left: auto;
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;
  }

  :deep(.el-input),
  :deep(.el-select) {
    width: 100%;
  }

  :deep(.el-textarea) {
    width: 100%;
  }

  :deep(.el-table) {
    margin-top: 15px;
  }

  :deep(.el-dialog__body) {
    padding: 20px 20px 0 20px;
  }

  :deep(.el-input-number .el-input__inner) {
    text-align: left;
  }

  .dialog-footer {
    text-align: right;
    padding: 20px;
    padding-top: 0;
  }

  :deep(.el-select-dropdown__item) {
    padding-right: 20px;
  }

  :deep(.el-select .el-tag) {
    margin: 2px 0 2px 6px;
  }

  :deep(.custom-tree-node) {
    display: flex;
    align-items: center;
    
    i {
      margin-right: 8px;
      
      &.dept-icon {
        color: #909399;
      }
      
      &.user-icon {
        color: #409EFF;
      }
    }
  }
  
  :deep(.el-tree-node__content) {
    height: 32px;
  }

  :deep(.el-tree-node.is-disabled > .el-tree-node__content) {
    cursor: not-allowed;
    background-color: #f5f7fa;
  }

  :deep(.el-tree-select) {
    width: 100%;
  }

  :deep(.vue-treeselect) {
    .vue-treeselect__control {
      border-radius: 4px;
      border-color: #DCDFE6;
      
      &:hover {
        border-color: #C0C4CC;
      }
    }
    
    .vue-treeselect__placeholder {
      color: #C0C4CC;
    }
    
    .vue-treeselect__single-value {
      color: #606266;
    }
    
    .vue-treeselect__multi-value {
      margin: 3px 0;
    }
    
    .vue-treeselect__multi-value-item {
      background: #f0f2f5;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      padding: 0 8px;
      margin-right: 6px;
      color: #606266;
    }
    
    .vue-treeselect__option--disabled {
      cursor: not-allowed;
      color: #C0C4CC;
      background: #F5F7FA;
    }
    
    .vue-treeselect__option--has-children {
      background: #FFFFFF;
      font-weight: bold;
      
      &:hover {
        background: #F5F7FA;
      }
    }
    
    .vue-treeselect__option:not(.vue-treeselect__option--disabled):hover {
      background: #F5F7FA;
    }
    
    .vue-treeselect__label-container {
      display: flex;
      align-items: center;
    }
  }
}
</style> 